<template>
    <div style="overflow-x:hidden">
        <BannerStatic :ban="wWidth<768?banner[1]:banner[0]" style="height: 550px;"></BannerStatic>
        <NewsList class="px-xs-32"></NewsList>
        <!-- <NewsDetail></NewsDetail> -->
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import NewsList from '@/components/news/newsList.vue'
// import NewsDetail from '@/components/news/newsDetail.vue'

export default {
    components:{
        BannerStatic,
        NewsList,
        // NewsDetail
    },
    data(){
        return{
            banner: [require('@/assets/bannerNews.jpg'),require('@/assets/phone/bannerNews.png')],
            wWidth: window.screen.width
        }
    }
}
</script>